// extracted by mini-css-extract-plugin
export default {"picker":"ColorItem_picker__Aq11+","overlay":"ColorItem_overlay__-PvhQ","withBorder":"ColorItem_withBorder__uwN1W"};